import { apiClient } from "../apiClient";
import { IClassListItem } from "../../model/respone/classes/IClassListItem";

export const classesApi = {
    GetList: () => apiClient.get<IClassListItem[]>("registration/classes"),
};
